<template>
    <div>
        <b-modal id="edit_subscriber_block_editor_modal"
                 size="xl" ok-title="Save" @ok="saveBlocks" no-close-on-backdrop>
            <template slot="modal-title">Edit blocks for {{name}}, max. {{maxBlocks}} blocks.</template>
            <v-app class="v-app v-appNoBackground">

                <v-expansion-panels accordion>
                    <filters-for-block-editor-panel @new-filterd-list="updateFilterList($event)"
                                                    v-bind:blocks="blocks"/>
                    <use-flow-template-panel v-bind:current-blocks="currentBlocks"
                                             v-bind:next-block-id-prop="nextBlockId"
                                             @next-block-id="updateNextBlockId($event)"/>
                    <add-block-to-current-blocks-panel v-bind:current-blocks="currentBlocks"
                                                       v-bind:blocks="blocks"
                                                       v-bind:next-block-id-prop="nextBlockId"
                                                       @next-block-id="updateNextBlockId($event)"/>
                </v-expansion-panels>

                <div>
                    <div class="col-12">
                        <div class="row col-12 blockEditorHeader">
                            <div class="col-1">
                                <h6>Move</h6>
                            </div>
                            <div class="col-5">
                                <h6>Block name</h6>
                            </div>
                            <div class="col-5">
                                <h6>Method name</h6>
                            </div>
                            <div class="col-1">
                                <h6>Action</h6>
                            </div>
                        </div>
                        <draggable v-model="currentBlocks"
                                   v-bind="dragOptions"
                                   handle=".handle">
                            <block v-for="(block, index) in currentBlocks"
                                   v-bind:key="block.id"
                                   v-bind:block.sync="block"
                                   v-bind:blockType="block.blockType"
                                   v-bind:options="filteredBlockList"
                                   v-bind:currentBlocks="currentBlocks"
                                   @deleteBlock="deleteBlock(index)">
                            </block>
                        </draggable>
                    </div>
                    <div class="row">
                        <v-spacer/>
                        <v-btn :style="secondaryStyle" @click="showMoreInfo(true)">
                            Show preview of the json and subscriber history
                        </v-btn>
                        <v-spacer/>
                    </div>
                </div>
            </v-app>
        </b-modal>

        <v-dialog v-model="moreInfoDialog" max-width="70vw">
            <v-toolbar flat>
                <v-toolbar-title>More info</v-toolbar-title>
                <v-spacer/>
                <v-btn icon @click="showMoreInfo(false)">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider style="margin: 0"/>
            <v-tabs vertical :color="sitionColor">
                <v-tab>current JSON preview</v-tab>
                <v-tab>Subscriber history</v-tab>
                <v-tab-item>
                    <v-card flat>
                        <v-card-text>
                            <pre class="dialogText">{{JSON.stringify(currentBlocks, null, 2)}}</pre>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
                <v-tab-item>
                    <v-expansion-panels accordion>
                        <v-expansion-panel v-for="(history, index) in subscriberHistory" :key="index">
                            <v-expansion-panel-header>{{history.usedUntil}}</v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <pre>{{JSON.stringify(history.connectorInfo, null, 2)}}</pre>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-tab-item>
            </v-tabs>
        </v-dialog>
    </div>
</template>

<script>
    import SubscriberRepository from '../../../repositories/subscriber.repository';
    import BlockRepository from '../../../repositories/block.repository';
    import draggable from 'vuedraggable'
    import Block from './Block.vue'
    import AddBlockToCurrentBlocksPanel from "./BlockEditorHelpers/AddBlockToCurrentBlocksPanel";
    import FiltersForBlockEditorPanel from "./BlockEditorHelpers/FiltersForBlockEditorPanel";
    import UseFlowTemplatePanel from "./BlockEditorHelpers/UseFlowTemplatePanel";

    export default {
        components: {
            Block,
            draggable,
            AddBlockToCurrentBlocksPanel,
            FiltersForBlockEditorPanel,
            UseFlowTemplatePanel,
        },
        props: {
            id: {
                type: Number,
                default: -1
            },
            name: {
                type: String,
                default: ''
            },
            currentBlocks: {
                type: Array,
                default: []
            },
            subscriberHistory: {
                type: Array,
                default: []
            }
        },
        data() {
            return {
                moreInfoDialog: false,
                nextBlockId: Number(process.env.VUE_APP_BLOCKEDITOR_MAX_BLOCKS + 1),
                maxBlocks: Number(process.env.VUE_APP_BLOCKEDITOR_MAX_BLOCKS),
                blocks: [],
                defaultMethodName: 'execute',
                filteredBlockList: [],
            }
        },
        methods: {
            showMoreInfo(show) {
                if (show) {
                    this.moreInfoDialog = true;
                    this.$bvModal.hide('edit_subscriber_block_editor_modal');
                } else {
                    this.moreInfoDialog = false;
                    this.$bvModal.show('edit_subscriber_block_editor_modal');
                }
            },
            updateFilterList(val) {
                this.filteredBlockList = val;
            },
            updateNextBlockId(val) {
                this.nextBlockId = val;
            },
            saveBlocks(event) {
                this.$emit('show-loading-pop-up', 'Saving the changes to the blocks');
                this.currentBlocks.forEach((block) => {
                    if (!block.methodName) {
                        block.methodName = this.defaultMethodName;
                    }
                    if (block.config !== undefined) {
                        try {
                            block.config = JSON.parse(block.config);
                        } catch (e) {
                            block.config = JSON.stringify(block.config);
                        }
                    }

                    delete block.id;
                });
                SubscriberRepository.setBlocks(this.id, this.currentBlocks).then(res => {
                    this.$emit('reset-loading-pop-up');
                    if (res.data.success) {
                        this.$bvModal.hide('edit_subscriber_block_editor_modal');
                        this.$bvToast.toast(`Blocks successfully edited.`, {
                            title: `Blocks edited.`,
                            variant: 'success',
                            solid: true
                        });
                    }
                }).catch(error => {
                    this.$emit('reset-loading-pop-up');
                    this.$bvModal.show('edit_subscriber_block_editor_modal');
                    this.$bvToast.toast('Looks like something went wrong on the server while editing the blocks.', {
                        title: `Block edit error.`,
                        variant: 'danger',
                        solid: true
                    });
                });
            },
            loadAllBlocks() {
                BlockRepository.getAllBlocks().then(res => {
                    if (res.data.success) {
                        this.blocks = res.data.blocks;
                    }
                });
            },
            deleteBlock(index) {
                this.$delete(this.currentBlocks, index);
            }
        },
        created() {
            this.loadAllBlocks();
        },
        computed: {
            dragOptions() {
                return {
                    animation: 200,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost"
                };
            }
        }
    }
</script>

<style>

    .expansionHeaderText > h6 {
        margin: 0 10px 0 0;
    }

    .blockEditorHeader {
        padding: 5px 5px 0;
    }

    .ghost {
        opacity: 0.5;
        background: lightgray;
    }

    .ghost > div {
        opacity: 0.5;
        background: lightgray;
    }

    .handle {
        float: left;
        cursor: all-scroll;
    }

</style>
